import NEXTPAGEHOVERICON    from './nextpage-hover.svg';
import NEXTPAGENORMALICON   from './nextpage-normal.svg';
import PENHOVERICON         from './pen-hover.svg';
import PENNORMALICON        from './pen-normal.svg';
import PREPAGEHOVERICON     from './prepage-hover.svg';
import PREPAGENORMALICON    from './prepage-normal.svg';
import STOPHOVERICON        from './stop-hover.svg';
import STOPNORMALICON       from './stop-normal.svg';
import TENCENTDOCSICON      from './Tencent-docs.svg';
import AUDIENCEPREPAGE         from './audience-prepage.svg';
import AUDIENCENEXTPAGE         from './audience-nextpage.svg';

export const NEXTPAGEHOVER       = NEXTPAGEHOVERICON;
export const NEXTPAGENORMAL      = NEXTPAGENORMALICON;
export const PENHOVER            = PENHOVERICON;
export const PENNORMAL           = PENNORMALICON;
export const PREPAGEHOVER        = PREPAGEHOVERICON;
export const PREPAGENORMAL       = PREPAGENORMALICON;
export const STOPHOVER           = STOPHOVERICON;
export const STOPNORMAL          = STOPNORMALICON;
export const TENCENTDOCS         = TENCENTDOCSICON;
export const AUDIENCEPREV        = AUDIENCEPREPAGE;
export const AUDIENCENEXT        = AUDIENCENEXTPAGE;
